/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Modal } from 'react-bootstrap';
import { Input, Button, Render, DocUpload, Select } from 'components';
import { Constants, Globals } from 'utils';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { PasswordActive, PasswordInactive, LogoutIcon, ArrowBottom } from 'assets/icons';
import { Crown, LogoWhite } from 'assets/img';
import ModalDNI from './components/modal-dni';
import ModalRIF from './components/modal-rif';
import SignatureCanvas from 'react-signature-canvas';
import ReactHtmlParser from 'react-html-parser';

const STEP = {
	STEP_1: 1,
	STEP_2: 2,
	STEP_3: 3,
	STEP_4: 4,
	END: 5,
}

const MODAL = {
	NONE: 0,
	DNI: 1,
	RIF: 2,
}

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class RegisterForm extends React.Component<Props> {

	canvas: any;
	scrollRef: any;

	state = {
		step: this.props.user ? STEP.STEP_2 : STEP.STEP_1,
		modal: MODAL.NONE,
		form: {
			user_type_id: this.props.location.pathname.endsWith('/business')
				? Constants.USER.USER_TYPE.COMPANY
				: Constants.USER.USER_TYPE.NATURAL,
			phone: '',
			name: '',
			city: '',
			email: '',
			password: '',
			password_confirm: '',
			photo_file: null,
			dni_file: null,
			rif_file: null,
			mercantil_file: null,
			signature: '',
			hasFile: true,
			phoneprefix_id: Constants.PHONEPREFIX.VE
		},
		activePassword: false,
		modal_data: {},
		visible_sign_txt: true,
		terms: '',
		phoneprefixes: [],
		btn_active: false
	}

	componentDidMount() {
		if (this.props.user && (this.props.user?.register_finished || this.props.user?.level_id != Constants.LEVELS.CLIENT)) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Registrar Natural',
				onBack: null
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await AuthService.getTerms({
			withoutLoading: true
		});
		this.setState({
			terms: res.terms || '',
			phoneprefixes: res.phoneprefixes || []
		});
	}

	setStep = (step: number) => {
		// if (step > this.state.step && !this.isValidForm()) return;

		this.setState({ step });
		setTimeout(() => {
			document.documentElement.scrollIntoView({ behavior: 'smooth' });
		}, 50);
	}

	setModal = (modal: number) => {
		this.setState({ modal });
	}

	togglePassword = () => {
		this.setState({ activePassword: !this.state.activePassword });
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target?.name]: e.target?.value
			}
		});
	}

	onChange = async (value: any, target: keyof typeof this.state.form) => {
		await this.setState({
			form: {
				...this.state.form,
				[target]: value
			}
		});

		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		if (target === 'dni_file') {
			const res: any = await AuthService.readDocument({
				hasFile: true,
				file: value,
				user_id: this.props.user?.id,
				document_type_id: Constants.DOCUMENT_TYPES.ID
			});
			if (!res.data.result) {
				this.setState({
					form: {
						...this.state.form,
						dni_file: null
					}
				});
				return onError('El documento cargado no corresponde al formato requerido. Por favor, sube el documento solicitado para continuar.');
			}
			this.setState({ modal: MODAL.DNI, modal_data: res.data });
		}
		else if (target === 'rif_file') {
			const res: any = await AuthService.readDocument({
				hasFile: true,
				file: value,
				user_id: this.props.user?.id,
				document_type_id: Constants.DOCUMENT_TYPES.RIF
			});
			if (!res.data.result) {
				this.setState({
					form: {
						...this.state.form,
						rif_file: null
					}
				});
				return onError('El documento cargado no corresponde al formato requerido. Por favor, sube el documento solicitado para continuar.');
			}
			this.setState({ modal: MODAL.RIF, modal_data: res.data });
		}
		else if (target === 'photo_file') {
			await AuthService.readDocument({
				hasFile: true,
				file: value,
				user_id: this.props.user?.id,
				document_type_id: Constants.DOCUMENT_TYPES.PHOTO
			});
		}
		else if (target === 'mercantil_file') {
			await AuthService.readDocument({
				hasFile: true,
				file: value,
				user_id: this.props.user?.id,
				document_type_id: Constants.DOCUMENT_TYPES.INCORPORATION
			});
		}
	}

	isValidForm = () => {
		const onError = (msg: string) => {
			Globals.showError(msg);
			return false;
		}

		const { form, step } = this.state;

		if (step === STEP.STEP_1) {
			if (!form.phone)
				return onError('Debe ingresar el teléfono');

			if (!form.name)
				return onError('Debe ingresar el nombre');

			if (!form.city)
				return onError('Debe ingresar la ciudad de residencia');

			if (!form.email)
				return onError('Debe ingresar el correo electrónico');

			if (!form.password)
				return onError('Debe ingresar la contraseña');

			if (form.password !== form.password_confirm)
				return onError('Las contraseñas no coinciden');

		}
		else if (step === STEP.STEP_2) {
			if (form.user_type_id === Constants.USER.USER_TYPE.NATURAL && !form.photo_file)
				return onError('Debe adjuntar una foto o logo');

			if (form.user_type_id === Constants.USER.USER_TYPE.NATURAL && !form.dni_file)
				return onError('Debe adjuntar la cédula');

			if (form.user_type_id === Constants.USER.USER_TYPE.COMPANY && !form.mercantil_file)
				return onError('Debe adjuntar el registro mercantil');

			// RIF es opcional para persona natural, obligatorio para empresa
			if (form.user_type_id === Constants.USER.USER_TYPE.COMPANY && !form.rif_file)
				return onError('Debe adjuntar el RIF');

		}

		return true;
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.isValidForm()) return;

		try {
			const res: any = await AuthService.register({
				user_type_id: this.state.form.user_type_id,
				phone: this.state.form.phone,
				name: this.state.form.name,
				city: this.state.form.city,
				email: this.state.form.email,
				password: this.state.form.password,
				password_confirm: this.state.form.password_confirm,
				phoneprefix_id: this.state.form.phoneprefix_id
			});
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
			await this.props.dispatch({
				type: 'SET_ACCESS_TOKEN',
				payload: res.access_token
			});
			this.setStep(STEP.STEP_2);
		} catch (error: any) {
			Globals.showError(error?.response?.data?.error);
		}
	}

	finishRegister = async () => {
		const res: any = await AuthService.finishRegister({
			sign: this.state.form.signature
		});
		if (res.user) {
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
		}
		this.setStep(STEP.END);
	}

	onLogout = () => {
		Globals.confirm('¿Desea cerrar sesión? Para finalizar el registro deberá iniciar sesión.', () => {
			this.props.dispatch({ type: 'SET_USER', payload: null });
			this.props.dispatch({ type: 'SET_ACCESS_TOKEN', payload: null });
			this.props.history.replace('/login');
			Globals.quitLoading();
		});
	}

	clear = () => {
		this.canvas.clear();
		this.setState({
			visible_sign_txt: true
		});
	}

	render() {
		const { form, modal, terms } = this.state;
		const prefix = this.state.phoneprefixes.find((i: any) => i.id == form.phoneprefix_id);

		return (
			<>
        <Modal
          show={modal === MODAL.DNI}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalDNI
            modal_data={ this.state.modal_data }
            file={this.state.form.dni_file}
            onClose={() => this.setModal(MODAL.NONE)}
          />
        </Modal>
        <Modal
          show={modal === MODAL.RIF}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalRIF
            modal_data={ this.state.modal_data }
            file={this.state.form.rif_file}
            onClose={() => this.setModal(MODAL.NONE)}
          />
        </Modal>

				<div id="register-form">
					<Render condition={this.state.step === STEP.STEP_1}>
						<div className="wrapper">
							<main className="step-1">
								<section>
									<p className="title">Datos persona encargada</p>

									<div className="input-group">
										<div className="container-phone">
											<div className="container-select">
												{/* Queda pendiente instalar plugin para que sea realmente un select, por ahora esta desactivado */}
												<div className="select-disabled">
													{/*
													// @ts-ignore */}
													<img src={ Constants.BASE_PUBLIC + 'img/' + prefix?.icon } />
													<img src={ ArrowBottom } className="arrow" />
												</div>
											</div>
											<Input
												maxLength={ 11 }
												type="number"
												label="Teléfono"
												placeholder="Ingresar datos"
												name="phone"
												value={form.phone}
												onChange={this.change}
											/>
										</div>
										<Input
											label="Nombre"
											placeholder="Ingresar datos"
											name="name"
											value={form.name}
											onChange={this.change}
										/>
										<Input
											label="Ciudad donde reside"
											placeholder="Ingresar datos"
											name="city"
											value={form.city}
											onChange={this.change}
										/>
									</div>
								</section>

								<section>
									<p className="title">Datos creación de cuenta</p>

									<div className="input-group">
										<Input
											label="Correo electrónico"
											placeholder="Ingresar datos"
											name="email"
											value={form.email}
											onChange={this.change}
										/>
										<Input
											type={this.state.activePassword ? 'text' : 'password'}
											label="Contraseña"
											placeholder="Ingresar datos"
											name="password"
											value={form.password}
											onChange={this.change}
											searchRight
											searchIcon={this.state.activePassword ? PasswordActive : PasswordInactive}
											onSubmit={this.togglePassword}
										/>
										<Input
											type={this.state.activePassword ? 'text' : 'password'}
											label="Repetir contraseña"
											placeholder="Ingresar datos"
											name="password_confirm"
											value={form.password_confirm}
											onChange={this.change}
											searchRight
											searchIcon={this.state.activePassword ? PasswordActive : PasswordInactive}
											onSubmit={this.togglePassword}
										/>
									</div>
								</section>

								<section className="actions">
									<Button className="back" color="primary flat rounded-full" onClick={() => this.props.history.goBack()}>
										Volver
									</Button>
									<Button className="continue" color="primary rounded-full" onClick={(e: any) => this.submit(e)}>
										Continuar
									</Button>
								</section>
							</main>
						</div>
					</Render>

					<Render condition={this.state.step === STEP.STEP_2}>
						<div className="wrapper">
							<div className="text-right">
								<button className="close" onClick={this.onLogout}>
									<img src={LogoutIcon} alt="Close" />
								</button>
							</div>

							<main className="step-2">
								<section>
									<DocUpload
										label="Foto / Logo de Perfil"
										isRequired={form.user_type_id === Constants.USER.USER_TYPE.NATURAL}
										file={form.photo_file}
										showImage
										message1="Arrastre y suelte su imagen aquí"
										accept="image/jpeg,image/png"
										onUpload={f => this.onChange(f, 'photo_file')}
									/>
									<Render condition={form.user_type_id === Constants.USER.USER_TYPE.NATURAL}>
										<DocUpload
											label="Cédula"
											isRequired
											file={form.dni_file}
											message1="Arrastre y suelte su archivo aquí"
											message2={'Este documento debe ser legible.\nFormatos aceptados: jpg, png, pdf no debe superar los 10MB.'}
											onUpload={f => this.onChange(f, 'dni_file')}
										/>
									</Render>
									<Render condition={form.user_type_id === Constants.USER.USER_TYPE.COMPANY}>
										<DocUpload
											label="Registro Mercantil"
											isRequired
											file={form.mercantil_file}
											message1="Arrastre y suelte su archivo aquí"
											message2={'Este documento debe ser legible.\nFormatos aceptados: jpg, png, pdf no debe superar los 10MB.'}
											onUpload={f => this.onChange(f, 'mercantil_file')}
										/>
									</Render>
									<DocUpload
										label="RIF"
										isRequired={form.user_type_id === Constants.USER.USER_TYPE.COMPANY}
										file={form.rif_file}
										message1="Arrastre y suelte su archivo aquí"
										message2={form.user_type_id === Constants.USER.USER_TYPE.NATURAL ? 'Opcional. Debe adjuntar este archivo en formato PDF.\nPeso máximo de este archivo 3MB.' : 'Debe adjuntar este archivo en formato PDF.\nPeso máximo de este archivo 3MB.'}
										onUpload={f => this.onChange(f, 'rif_file')}
									/>
								</section>

								<section className="actions">
									{/*<Button
										className="back"
										color="primary flat rounded-full"
										onClick={() => this.setStep(STEP.STEP_1)}
									>
										Volver
									</Button>*/}
									<Button
										className="continue"
										color="primary rounded-full" 
										onClick={() => {
											if (!this.isValidForm()) return;
											this.setStep(STEP.STEP_3);
									  }}
									>
										Continuar
									</Button>
								</section>
							</main>
						</div>
					</Render>

					<Render condition={this.state.step === STEP.STEP_3}>
						<div className="wrapper">
							<main className="step-3">
								<section>
									<p className="title">Términos y Condiciones</p>

									<div className="content" style={{ position: 'relative' }} ref={ref => this.scrollRef = ref} onScroll={() => {
										if (this.scrollRef) {
								      const { scrollTop, scrollHeight, clientHeight } = this.scrollRef;
								     
								      if (scrollTop + clientHeight >= scrollHeight - 5) {
								      	this.setState({
								      		btn_active: true
								      	});
								      }
								    }
									}}>
										{ ReactHtmlParser(terms) }

										<div className="signature">
											<SignatureCanvas
												ref={ (ref: any) => this.canvas = ref }
												onBegin={ () => {
													this.setState({
														visible_sign_txt: false
													});
												} }
												canvasProps={{
													height: 170,
													className: 'sigCanvas'
												}} />
											{
												this.state.visible_sign_txt && (
													<span>Firme aquí</span>
												)
											}
										</div>

										<div className="text-center">
											<Button
												style={{ maxWidth: '200px' }}
												className="reset"
												color="primary flat rounded-full"
												onClick={() => this.clear()}
											>
												Limpiar
											</Button>
										</div>
									</div>
								</section>

								<section className="actions">
									<Button
										className="back"
										color="primary flat rounded-full"
										onClick={() => this.setStep(STEP.STEP_2)}
									>
										Volver
									</Button>
									<Button
										className={ `continue ${ !this.state.btn_active ? 'disabled' : '' }` }
										color="secondary rounded-full"
										disabled={ !this.state.btn_active }
										onClick={async () => {
											if (this.state.btn_active) {
												if (this.state.visible_sign_txt) {
													Globals.showError("Por favor, firme el contrato para continuar");
													return;
												}
												await this.setState({
													form: {
														...this.state.form,
														signature: this.canvas.toDataURL().replace('data:image/png;base64,',''),
													}
												});
												this.setStep(STEP.STEP_4);
											}
									  }}
									>
										Continuar
									</Button>
								</section>
							</main>
						</div>
					</Render>

					<Render condition={this.state.step === STEP.STEP_4}>
						<div className="wrapper">
							<main className="step-4">
								<section>
									<p className="title">Términos y Condiciones</p>

									<div className="accepted">
										<div className="logo-wrapper">
											<img src={Crown} alt="Logo" />
										</div>
										<div className="accepted-details">
											<p className="accepted-label">Contrato Aceptado</p>
											<p className="accepted-sublabel">Términos aceptados exitosamente</p>
										</div>
									</div>

									<div className="content">
										{ ReactHtmlParser(terms) }
									</div>
								</section>

								<hr />

								<div className="text-center">
									<img 
									  src={`data:image/png;base64,${this.state.form.signature}`}
									  style={{ width: '350px', objectFit: 'contain', margin: '0 auto' }}
									/>
								</div>

								<section className="actions">
									<Button
										className="back"
										color="primary flat rounded-full"
										onClick={() => {
											this.setState({
												visible_sign_txt: true
											});
											this.setStep(STEP.STEP_3);
										}}
									>
										Volver
									</Button>
									<Button
										className="continue"
										color="primary rounded-full"
										onClick={() => this.finishRegister()}
									>
										Continuar
									</Button>
								</section>
							</main>
						</div>
					</Render>

					<Render condition={this.state.step === STEP.END}>
						<div className="step-end">
							<main className="end-card">
								<div className="container-logo">
									<img src={LogoWhite} alt="Logo" />
								</div>
								<section>
									<p className="title">¡Casi finalizamos!</p>
									<p className="subtitle">El proceso de verificación puede tardar un tiempo, sin embargo ya puede iniciar sesión con el correo y contraseña antes especificados</p>

									<Button
										className="continue"
										color="secondary rounded-full"
										onClick={() => this.props.history.replace('/')}
									>
										Continuar
									</Button>
								</section>
							</main>
						</div>
					</Render>
				</div>
			</>
		)
	}
}

export default connect((state: RootState) => ({
	user: state.user
}))(RegisterForm);